import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { useI18n } from "@/context/I18nContext";
import { Loader2 } from "lucide-react";

export function ProgressStep({ progress }) {
  const { t } = useI18n();
  const pct = progress.total > 0 ? Math.round((progress.done / progress.total) * 100) : 0;

  return (
    <Card className="flex flex-1 flex-col items-center justify-center gap-4 p-10" data-testid="bulk-update-progress">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      <h2 className="text-lg font-semibold">{t("bulkUpdate.progress.title")}</h2>
      <div className="w-full max-w-md">
        <Progress value={pct} />
      </div>
      <p className="text-sm text-muted-foreground" data-testid="bulk-update-progress-count">
        {t("bulkUpdate.progress.count", progress.done, progress.total)}
      </p>
    </Card>
  );
}
